import React from 'react'

import { IconProps } from '../Types'

export const VoiceOffFill = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="VoiceOffFill"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path d="m18.87,11.05c-.58,0-.99.41-.99,1,0,.66-.17,1.33-.41,1.99-.25.66-.66,1.24-1.16,1.66-.5.42-1.08.83-1.66,1.16-.66.25-1.32.41-1.99.41h-2.07c-.58,0-.99.41-1.08.91,0,.58.41,1,.91,1.08h.5v1.74c0,.58.41,1,.99,1s.99-.41.99-1v-1.74c.83,0,1.66-.25,2.48-.5.91-.33,1.66-.91,2.32-1.58.66-.66,1.16-1.49,1.57-2.32.33-.91.58-1.83.58-2.74,0-.66-.41-1.08-.99-1.08Z"/><path d="m13.41,15.44c.17,0,.25,0,.41-.08.99-.41,1.82-1.24,2.24-2.24.25-.5,0-1.08-.5-1.33-.5-.25-1.08,0-1.33.5-.25.58-.66,1-1.24,1.24-.5.25-.75.83-.5,1.33.17.41.5.58.91.58ZM21.69,2.33c-.41-.41-.99-.41-1.41,0l-3.81,3.82c-.08-1.08-.5-2.07-1.32-2.82-.83-.83-1.99-1.33-3.15-1.33-1.16.08-2.24.5-3.06,1.33-.83.83-1.33,1.99-1.33,3.15v4.81c0,.66.17,1.41.5,1.99.17.25.33.5.5.75l-1.24,1.24c-.25-.33-.5-.75-.75-1.16-.33-.66-.5-1.41-.5-2.16,0-.58-.41-1-.99-1s-.99.41-.99,1c0,1,.25,2.07.66,2.99.25.58.66,1.16,1.08,1.66l-3.56,3.57c-.41.41-.41,1,0,1.41.17.17.41.33.66.33s.5-.08.66-.33l6.87-6.89L21.69,3.74c.41-.41.41-1,0-1.41Z"/>',
    }}
  />
)

VoiceOffFill.displayName = 'VoiceOffFill'

export const tags = ['VoiceOffFill', '']
